module.exports = __webpack_public_path__ + "img/assurCare.b82ce41b.png";